import { createContext, Dispatch, ReactNode, SetStateAction, useState } from "react";

import { FetusModalStatus } from "@/enums/FetusModalStatus";

type PartogramFetusContextType = {
	fetusModalStatus: FetusModalStatus;
	setFetusModalStatus: Dispatch<SetStateAction<FetusModalStatus>>;
	currentPartogramDataId: number;
	setCurrentPartogramDataId: Dispatch<SetStateAction<number>>;
	currentPartogramFetusId: number;
	setCurrentPartogramFetusId: Dispatch<SetStateAction<number>>;
};

type PartogramFetusContextProviderProps = {
	children: ReactNode;
};

export const PartogramFetusContext = createContext({} as PartogramFetusContextType);

export function PartogramFetusContextProvider({ children }: PartogramFetusContextProviderProps) {
	const [fetusModalStatus, setFetusModalStatus] = useState<FetusModalStatus>(
		FetusModalStatus.Registering
	);
	const [currentPartogramDataId, setCurrentPartogramDataId] = useState(0);
	const [currentPartogramFetusId, setCurrentPartogramFetusId] = useState(0);

	return (
		<PartogramFetusContext.Provider
			value={{
				fetusModalStatus,
				setFetusModalStatus,
				currentPartogramDataId,
				setCurrentPartogramDataId,
				currentPartogramFetusId,
				setCurrentPartogramFetusId,
			}}
		>
			{children}
		</PartogramFetusContext.Provider>
	);
}
